/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import WarningIcon from '@material-ui/icons/Warning';
import ErrorIcon from '@material-ui/icons/Error';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: '.25rem',
  },
  icon: {
    marginRight: '.375rem',
    verticalAlign: 'middle',
    fontSize: '1rem',
    '&--error': {
      color: theme.palette.error.main,
    },
    '&--warning': {
      color: theme.palette.warning.main,
    },
  },
  text: {
    verticalAlign: 'middle',
    color: theme.palette.input,
    '&--error': {
      color: theme.palette.error.main,
    },
  },
}));

// TODO Tests
function AssistiveText(props) {
  const classes = useStyles();

  const { dismissIcon = false, textStyle = null } = props;

  function hasIcon() {
    return props.severity === 'error' || props.severity === 'warning';
  }

  return (
    <div id={props.id} className={classes.root}>
      {hasIcon() && !dismissIcon && props.severity === 'error' && (
        <WarningIcon fontSize="small" className={classNames(classes.icon, `${classes.icon}--${props.severity}`)} />
      )}
      {hasIcon() && !dismissIcon && props.severity === 'warning' && (
        <ErrorIcon fontSize="small" className={classNames(classes.icon, `${classes.icon}--${props.severity}`)} />
      )}
      <Typography
        variant="body2"
        component="span"
        className={classNames(classes.text, textStyle, `${classes.text}--${props.severity}`)}
      >
        {props.children}
      </Typography>
    </div>
  );
}

AssistiveText.propTypes = {
  severity: PropTypes.oneOf(['error', 'warning', 'info']),
};

AssistiveText.defaultProps = {
  severity: 'info',
};

export default AssistiveText;
